import { render, staticRenderFns } from "./xsb-login.vue?vue&type=template&id=6be591e6&scoped=true&"
import script from "./xsb-login.vue?vue&type=script&lang=js&"
export * from "./xsb-login.vue?vue&type=script&lang=js&"
import style0 from "./xsb-login.vue?vue&type=style&index=0&id=6be591e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be591e6",
  null
  
)

export default component.exports